module.exports = __webpack_public_path__ + "img/footer.datang.92b9ab11.png";